import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

@Injectable({
	providedIn: 'root'
})
export class ClientService {

	constructor(
		private http: HttpClient
	) { }

	getClient(companyId: string, username: string, procoreUserId: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('companyId', companyId);
		params = params.set('username', username);
		params = params.set('procoreUserId', procoreUserId);

		const requestUrl = `${environment.serviceUrl}/client`;

		return this.http.get<any>(requestUrl, { headers, params });
	}

	getExportHistoriesByProjectId(companyId: string, projectId: string, username: string, procoreUserId: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('companyId', companyId);
		params = params.set('projectId', projectId);
		params = params.set('username', username);
		params = params.set('procoreUserId', procoreUserId);

		const requestUrl = `${environment.serviceUrl}/client/project/exports`;

		return this.http.get<any>(requestUrl, { headers, params });
	}

	createClient(companyId: string, username: string, procoreUserId: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('username', username);
		params = params.set('procoreUserId', procoreUserId);

		let body = {
			'procoreCompanyId': companyId,
			'dropboxExportParentFolderId': ''
		};

		const requestUrl = `${environment.serviceUrl}/client`;

		return this.http.post<any>(requestUrl, body, { params, headers });
	}

	updateClient(companyId: string, parentFolderId: string, username: string, procoreUserId: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('username', username);
		params = params.set('procoreUserId', procoreUserId);

		let body = {
			'procoreCompanyId': companyId,
			'dropboxExportParentFolderId': parentFolderId
		};

		const requestUrl = `${environment.serviceUrl}/client`;

		return this.http.patch<any>(requestUrl, body, { params, headers });
	}

}
